module.exports = __webpack_public_path__ + "img/背景.d91b589c.png";